import { render, staticRenderFns } from "./LatestMembers.vue?vue&type=template&id=39a396ac"
import script from "./LatestMembers.vue?vue&type=script&lang=js"
export * from "./LatestMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports